import React from 'react';
import './carousel.css';
import Search from '../Search/Search';

const Carousel = ({ bannerData, search, name }) => {
  return (
    <div id={name} className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        {bannerData && bannerData.map((item, index) => (
          <div
            key={index}
            className={index === 0 ? "carousel-item active" : "carousel-item"}
          >
            <a href={item.url} target="_blank" rel="noreferrer">
              <div className="slide-content">
                <div className="slide-text">
                  <h2>{item.titulo}</h2>
                  <p>{item.descripcion}</p>
                </div>
                <div className="slide-image">
                  <img src={item.imagen} alt={item.titulo || 'Banner'} />
                </div>
              </div>
            </a>
          </div>
        ))}
        {search ? <Search /> : null}
      </div>

      <button className="carousel-control-prev" type="button"
        data-bs-target={"#" + name} data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button"
        data-bs-target={"#" + name} data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;